import { IconButton, IconButtonProps } from '@mui/material';
import { IconTrash } from '@tabler/icons-react';
import { DS } from './ds';

interface DeleteButtonProps extends Omit<IconButtonProps, 'children'> {
  iconSize?: number;
}

const DeleteButton = ({ iconSize = 18, sx, ...rest }: DeleteButtonProps) => (
  <IconButton
    size="small"
    title="Eliminar"
    sx={{ color: DS.error, '&:hover': { bgcolor: '#fee2e2' }, ...sx }}
    {...rest}
  >
    <IconTrash size={iconSize} />
  </IconButton>
);

export default DeleteButton;
